function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeaderMedia.css';
import React from 'react';
import { get, canUseDOM, pathJoin, getDomain } from '../../utils';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { ReactComponent as IconPlaySharedCh } from '../../resources/icons/IconPlaySharedCh.svg';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { tealiumClickFunc } from '../../utils/tealium';
import { useVideoModal } from '../atoms/VideoModal/VideoModal';
import { RenderVideo } from '../atoms/VideoModal/RenderVideo';
const HeaderMedia = _ref => {
  let {
    fields,
    params,
    carouselEvent,
    mediaDesc,
    rendering,
    isSharedStyles = false,
    getCarouselAutoplay
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const isSharedCh = isSharedStyles ? isSharedStyles : get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const imageSrc = get(fields, 'data.item.image.jss.value.src', '');
  const imageAlt = get(fields, 'data.item.image.jss.value.alt', '');
  const videoSrc = get(fields, 'data.item.video.jss.value.href', '');
  const videoName = get(fields, 'data.item.name', '');
  const videoType = get(fields, 'data.item.video.jss.value.linktype', '');
  const imageRef = React.useRef();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const publicationDate = get(fields, 'data.item.publicationDate.jss.value', '');
  const videoDescription = get(fields, 'data.item.description');
  const {
    modalVideoState,
    setModalVideoState,
    isShown,
    toggle,
    checkMouseMoved,
    startOnce,
    setStartOnce
  } = useVideoModal();
  React.useEffect(() => {
    if (isSharedCh && getCarouselAutoplay) {
      getCarouselAutoplay(!isShown);
    }
  }, [isShown]);
  const script = videoType !== 'external' ? `{
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "${videoName}",
      "description": "${videoDescription ? videoDescription : mediaDesc}",
      "thumbnailUrl": ["${pathJoin([getDomain(), imageSrc])}"],
      "uploadDate": "${publicationDate}",
      "contentUrl": "${pathJoin([getDomain(), videoSrc])}"
    }` : `{
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "${videoName}",
      "description": "${videoDescription ? videoDescription : mediaDesc}",
      "thumbnailUrl": ["${pathJoin([getDomain(), imageSrc])}"],
      "uploadDate": "${publicationDate}",
      "embedUrl": "${videoSrc}"
    }`;
  if (!fields || !imageSrc) {
    console.info('HeaderMedia component render skipped. No fields provided');
    return pageEditing ? /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, "[Header Media: please provide data source or item should have headerImage field]") : null;
  }
  const imgLoadedEvent = () => {
    if (canUseDOM) {
      let isHeaderGeneric = imageRef.current.closest('.header-generic--primary');
      if (isHeaderGeneric) {
        let animButton = isHeaderGeneric.getElementsByClassName('header-animation-trigger');
        if (animButton && animButton.length) animButton[0].click();
      }
    }
  };
  const renderVideoSharedComponent = () => {
    console.log('videoSrc', videoSrc);
    if (videoSrc && videoType) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn__icon--desktop",
        onClick: () => {
          setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
            type: videoType,
            src: videoSrc,
            title: ''
          }));
          toggle();
        }
      }, /*#__PURE__*/React.createElement(IconPlaySharedCh, null)), /*#__PURE__*/React.createElement(RenderVideo, {
        modalVideoState: modalVideoState,
        isSharedCh: isSharedCh,
        isShown: isShown,
        setModalVideoState: setModalVideoState,
        toggle: toggle,
        checkMouseMoved: checkMouseMoved,
        startOnce: startOnce,
        setStartOnce: setStartOnce
      }));
    }
    return null;
  };
  const renderImage = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("picture", {
    className: "styled-curved-image"
  }, canUseDOM && document.getElementsByClassName('header-events').length === 1 ? /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    "data-header": "event",
    srcSet: `${imageSrc}&cw=795&ch=595`
  }) : /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    "data-header": "normal",
    srcSet: `${imageSrc}&cw=1556&ch=690`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${imageSrc}&cw=397&ch=397`,
    ref: imageRef,
    onLoad: imgLoadedEvent,
    alt: imageAlt,
    "aria-hidden": "true",
    "aria-label": imageAlt
  })), isSharedCh ? renderVideoSharedComponent() : /*#__PURE__*/React.createElement(React.Fragment, null, videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
    videoSrc: videoSrc,
    videoType: videoType,
    loop: true,
    buttonTopAlignment: true,
    click: param => {
      tealiumClickFunc(params, `${param}: ${videoName}`);
    },
    carouselEvent: carouselEvent,
    structuredScriptData: script,
    structuredScript: true,
    isSharedCh: isSharedCh
  })), pageEditing && /*#__PURE__*/React.createElement(Image, {
    editable: true,
    field: get(fields, 'data.item.image.jss')
  }));
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl,
    isSharedCh: isSharedCh
  }, imageSrc && renderImage());
};
const StyledContainer = _ref2 => {
  let {
    children,
    rtl,
    isSharedCh
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `header-media ${isSharedCh ? commonSharedStyles : commonStyles}  ${rtl ? isSharedCh ? rtlSharedStyles : rtlStyles : isSharedCh ? ltrSharedStyles : ltrStyles} ${isSharedCh ? headerImageSharedStyle : headerImageStyle}`
  }, children);
};
const commonStyles = "c1vj5c55";
const ltrStyles = "ll439xg";
const rtlStyles = "r1on2m9h";
const commonSharedStyles = "cxagdqq";
const ltrSharedStyles = "lo51di4";
const rtlSharedStyles = "rblvrem";
export const headerImageSharedStyle = "h1pw5z3g";
export default HeaderMedia;